<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * Reacoes com emoji da mensagem, no formato gravado por Uazapi::ReactionStore:
 * { emoji, actor: 'contact'|'account', name, at }. `name` pode vir ausente
 * (o backend omite a chave quando e nula via `.compact`).
 */
const props = defineProps({
  reactions: { type: Array, default: () => [] },
});

const { t } = useI18n();

const list = computed(() =>
  (props.reactions || []).filter(reaction => reaction?.emoji)
);

const titleFor = reaction =>
  reaction.name
    ? t('CONVERSATION.REACTIONS.TOOLTIP', { name: reaction.name })
    : t('CONVERSATION.REACTIONS.TOOLTIP_UNKNOWN');
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="list.length" class="flex flex-wrap gap-1 mt-1">
    <span
      v-for="(reaction, index) in list"
      :key="`${reaction.actor}-${index}`"
      data-testid="message-reaction"
      :title="titleFor(reaction)"
      class="inline-flex items-center px-1.5 py-0.5 text-sm rounded-full bg-n-alpha-2 border border-n-weak"
    >
      {{ reaction.emoji }}
    </span>
  </div>
</template>
